// Teléfono del cliente de la sesión para el evaluate: con él Promociones sabe si llegó recomendado.
import type { QueryClient } from '@tanstack/react-query';
import { WIZARD_KEYS } from '@/domains/sales/wizard/api/useWizard';
import type { WizardSession } from '@/domains/sales/wizard/types';
import { fromStoredPhone } from '@/lib/phoneMx';
import type { PromotionsApi } from './applySelection';

/** Teléfono a 10 dígitos de la sesión en caché; `undefined` si no hay sesión o no es válido. */
export function customerPhoneOf(sessionId: string, queryClient?: QueryClient): string | undefined {
    const session = queryClient?.getQueryData<WizardSession>(WIZARD_KEYS.session(sessionId));
    const phone = fromStoredPhone(session?.phone);
    return phone.length === 10 ? phone : undefined;
}

/** La misma API, pero cada evaluate lleva el teléfono del cliente leído al momento de llamar. */
export function withCustomerPhone(
    api: PromotionsApi,
    sessionId: string,
    queryClient?: QueryClient,
): PromotionsApi {
    return {
        ...api,
        evaluate: (request) => {
            const phone = request.phone ?? customerPhoneOf(sessionId, queryClient);
            return api.evaluate({ ...request, ...(phone && { phone }) });
        },
    };
}
